import React from "react";
import LoginC from "../../../stories/auth/login-box";
import styles from "./login.module.scss";
import version from "../../../../package.json";
const Login = () => {
  return (
    <div className={styles.loginBg}>
      <LoginC />
      <div className={styles.version}>Version: {version.version}</div>
    </div>
  );
};

export default Login;
